module.exports = __webpack_public_path__ + "img/not-authorized-dark.5afaa2ca.svg";